import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCardViewerAsync, CardViewerResponse, CardViewerParameters } from './CardViewerService';

const fetchCardViewerDataAsync = createAsyncThunk(
  'CardViewer/fetchCardViewerData',
  async (params: CardViewerParameters) => {
    return await fetchCardViewerAsync(params.groupName, params.pageNumber, params.pageSize, params.cardType);
  },
);

const initialState: CardViewerResponse = {
  values: [],
  totalCount: 0,
  pageNumber: 1,
  pageSize: 1,
  totalPages: 0,
  isLoading: false,
  error: null,
};

const cardViewerSlice = createSlice({
  name: 'CardViewer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCardViewerDataAsync.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchCardViewerDataAsync.fulfilled, (state, action) => {
      if (action.meta.arg.pageNumber > 1) {
        state.values = [...state.values, ...action.payload.values];
      } else {
        state.values = action.payload.values;
      }
      state.totalCount = action.payload.totalCount;
      state.pageNumber = action.payload.pageNumber;
      state.pageSize = action.payload.pageSize;
      state.totalPages = action.payload.totalPages;
      state.isLoading = false;
    });
    builder.addCase(fetchCardViewerDataAsync.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message || 'Failed to fetch CardViewer data';
    });
  },
});

export { fetchCardViewerDataAsync };
export default cardViewerSlice.reducer;
